import styled from 'styled-components';
import { SubTitle } from '../../atoms/Fonts';

export const TextFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
